var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-page",
    {
      attrs: {
        "is-showing-bandana": false,
        "is-showing-sitewide-modal": false,
      },
    },
    [
      _c(
        "template",
        { slot: "header" },
        [
          _vm._t("page-header", function () {
            return [_c("wa-page-header-simple", { key: "header" })]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "content" },
        [
          _vm._t("page-content", function () {
            return [
              _c(
                "main",
                {
                  staticClass: "app-content padding-y-6xl",
                  style: {
                    "background-image": `${_vm.contentBackground}`,
                    "--fa-secondary-opacity": "1.0",
                    "--fa-primary-color": "var(--fa-navy)",
                    "--fa-secondary-color": "var(--white)",
                  },
                  attrs: { role: "main" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "container" },
                    [
                      _c(
                        "div",
                        { class: `line-length-${_vm.lineLength} margin-auto` },
                        [
                          _vm._t("card", function () {
                            return [
                              _c(
                                "article",
                                {
                                  class: `card roomy ${_vm.theme}`,
                                  style: _vm.componentStyle,
                                },
                                [
                                  _vm._t("header", function () {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "header padding-y-4xl" },
                                        [
                                          _vm.decorativeIconName ===
                                          "faBlockQuestion"
                                            ? _c("wa-question-mark-block", {
                                                attrs: {
                                                  "block-color":
                                                    "var(--fa-navy)",
                                                  "block-hover-primary-color":
                                                    "var(--fa-navy)",
                                                  "block-hover-secondary-color":
                                                    "var(--fa-dk-yellow)",
                                                  "block-size": "4x",
                                                },
                                              })
                                            : _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: _vm.$v6[
                                                    _vm.decorativeIconStyle
                                                  ][_vm.decorativeIconName],
                                                  size: "4x",
                                                  "fixed-width": "",
                                                },
                                              }),
                                        ],
                                        1
                                      ),
                                    ]
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      class: `section text-left ${_vm.isSectionCompact}`,
                                    },
                                    [
                                      _vm._t("title", function () {
                                        return [
                                          _vm.hasTitle
                                            ? _c(
                                                "h1",
                                                {
                                                  staticClass:
                                                    "h4 margin-bottom-md",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(_vm.title) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      }),
                                      _vm._v(" "),
                                      _vm._t("copy", function () {
                                        return [
                                          _c("p", [_vm._v(_vm._s(_vm.copy))]),
                                        ]
                                      }),
                                      _vm._v(" "),
                                      _vm._t("action"),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _vm._t("footer"),
                                ],
                                2
                              ),
                            ]
                          }),
                          _vm._v(" "),
                          _vm._t("tip"),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._t("extras"),
                    ],
                    2
                  ),
                ]
              ),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("wa-page-footer-simple", {
        attrs: { slot: "footer" },
        slot: "footer",
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }